<template>
  <div class="container">
    <app-header title="我的收货地址" />
    <div class="main">
      <div class="title" v-if="list.length > 0">选择收货地址</div>

      <van-radio-group v-model="radio">
        <div class="item"
             v-for="(item,index) in list">
          <div class="tel" @click="toOrderPage(item)">
            <div>
              <span>{{item.name}}</span>
              <span>{{item.tel}}</span>
            </div>

            <van-radio :name="item.id"
                       checked-color="#FE003B"  @click.native.prevent="submit">设为默认</van-radio>
          </div>
          <div class="address">
            <!--<span v-if="item.isDefault" style="border: 1px solid #fe003b;">默认</span>-->
            {{item.address}}{{item.detail}}
          </div>
          <div class="caozuo">
            <span style="margin-right: 10px" @click="deleteShopAddress(item.id)">删除</span>
            <span style="margin-right: 10px" @click="onNavigateEdit(item.id)">编辑</span>
          </div>
        </div>
      </van-radio-group>
      <div class="footer">
        <div class="save" @click="onNavigate">添加新地址</div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryShopAddressList, saveShopAddress, updateShopAddress, defaultAddress,deleteShopAddress } from '@/api/address'
export default {
  name: "index",
  data () {
    return {
      currentItem: '',
      path: '',
      query: '',
      radio: 0,
      list: []
    }
  },
  created () {
    this.query = this.$route.query
    this.currentItem = this.$route.query.currentItem
    this.path = this.$route.query.path
    let rows = this.$route.query.rows
    if (rows) {
      this.rows = JSON.parse(rows)
    }
    this.getList()
  },
  methods: {
    toOrderPage(item){
      this.$route.params.item = this.currentItem
      this.$router.push({
        path: this.path,
        query: {
          ...this.query,
          address: JSON.stringify(item)
        }
      })
    },
    deleteShopAddress(id){
      this.$dialog.confirm({
        title: '是否确认删除？'
      }).then(() => {
        deleteShopAddress({id: id}).then(res=>{
          if (res.success){
            this.$toast.success('删除成功')
            this.getList()
          }
        })
      }).catch(() => {

      });
    },
    submit () {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      defaultAddress({ id: this.radio, uid: userInfo.id, isDefault: true }).then(res => {
        if (res.success) {
          //this.orderPage()
        } else {
          this.$toast.fail(res.msg)
        }
      })
    },
    onNavigateEdit(id){
      this.$router.push({
        path: '/address/edit',
        query: {
          id: id
        }
      })
    },
    onNavigate() {
      this.$router.push({
        path: '/address/add'
      })
    },
    orderPage() {
      this.$router.go(-1)
    },
    getList() {
      var user = localStorage.getItem("userInfo")
      user = JSON.parse(user)
      queryShopAddressList({ uid: user.id }).then(res => {
        if (res.success) {
          this.list = res.data
          this.list.forEach(item => {
            if (item.isDefault){
              this.radio = item.id;
            }
          });
        }
      })
    },
    save () {
      saveShopAddress({}).then(res => {
        if (res.success) {
          this.$toast.success("添加成功")
        } else {
          this.$toast.fail(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .main {
    position: relative;
    padding: 12px;
    .editBtn {
      position: absolute;
      top: 7px;
      right: 13px;
      font-size: 12px;
      background-color: #fa557b;
      color: #fff;
      border: 1px solid #ccc;
    }
    .title {
      height: 22px;
      font-size: 16px;
      font-weight: bold;
      line-height: 22px;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 12px;
    }
    .item {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.16);
      margin-bottom: 4px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      padding: 15px 12px;
      .tel {
        /*margin-top: 16px;*/
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .address {
        margin-top: 6px;
      }
      .caozuo{
        display: flex;
        flex-direction: row-reverse;
      }
    }
    .footer {
      margin-top: 10px;
      /*position: fixed;*/
      /*left: 12px;*/
      /*right: 12px;*/
      /*bottom: 12px;*/
      .submit {
        height: 40px;
        border: 1px solid rgba(254, 0, 59, 1);
        border-radius: 4px;
        line-height: 40px;
        text-align: center;
        background: linear-gradient(
          0deg,
          rgba(244, 4, 66, 1) 0%,
          rgba(226, 23, 75, 0.73) 100%
        );
        color: #ffffff;
      }
      .save {
        height: 40px;
        border: 1px solid rgba(254, 0, 59, 1);
        border-radius: 4px;
        line-height: 40px;
        text-align: center;
        margin-top: 20px;
        color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/address/list.vue